import { Link } from "react-router-dom";
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { IoToday } from "react-icons/io5";

export default function Home() {
  return (
    <div className="main-body">
      <div className="container">
        <div className="main-img">
          <img
            src="/maine.webp"
            alt="a view from the top of a hill"
            id="main-img"
            width="660px"
            height="357px"
          />
          
        </div>

        <div className="home-text">
          <h1>Welcome</h1>
          <p>
            This is my modest slice of the internet - no algorithms, no ads,
            just me tinkering with code and sharing whatever catches my
            interest. It&apos;s a work in progress, but isn&apos;t that the
            point?
          </p>
          <p>
            I enjoy climbing to the top of moderately sized hills and taking
            pictures.
          </p>
        </div>
        <div className="home-navigation">
          <Link to="/Links">
            <div className="home-card">
              <div className="home-card-img">
                <FaExternalLinkSquareAlt />
              </div>
              <div className="link-text">
                
                  <h2>Links</h2>
                
                <p className="link-quote">
                  An unorganized list of *things* I have found insteresting, insightful, or fun. 
                </p>
              </div>
            </div>
          </Link>
          <Link to="/now">
            <div className="home-card">
              <div className="home-card-img">
                <IoToday />
              </div>
              <div className="link-text">
                
                  <h2>Now</h2>
                
                <p className="link-quote">Here is what I&apos;m up to now.</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
